import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export function api__getOrderWithPaymentInfo(_x, _x2) {
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}
function _api__getOrderWithPaymentInfo() {
  _api__getOrderWithPaymentInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(orderId, post_id) {
    var _res$data, _res$data2, _res$data2$data, _res$data3;
    var includes, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          includes = ['roadService', 'warranty', 'banks'];
          if (orderId) {
            includes.push('payment_info');
          }
          if (!(!orderId && !post_id)) {
            _context.next = 4;
            break;
          }
          throw new Error("orderId or post_id is required");
        case 4:
          _context.next = 6;
          return fetcher().post("/order/get-details?include=".concat(includes.join(',')), {
            orderid: orderId,
            post_id: post_id,
            is_online: 1
          });
        case 6:
          res = _context.sent;
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && (_res$data2$data = _res$data2.data) !== null && _res$data2$data !== void 0 && _res$data2$data.post_id && !Array.isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data))) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", res.data.data);
        case 9:
          throw new Error("Failed to get order details");
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}